import styled from 'styled-components';

export const DashboardTitle = styled.h1`
  margin: 0;
  font-family: Raleway, sans-serif;
  text-transform: uppercase;
  font-size: 20px;
`
